import Backdrop from "@mui/material/Backdrop";
import { Box } from "@mui/material";

export default function LoaderFullScreen() {
  return (
    <Backdrop
      open
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backdropFilter: "blur(1px)",
        backgroundColor: "rgba(0,0,0,0.1)",
      }}
    >
      <Box sx={dotWrapper}>
        <Box sx={{ ...dot, animationDelay: "0s" }} />
        <Box sx={{ ...dot, animationDelay: "0.2s" }} />
        <Box sx={{ ...dot, animationDelay: "0.4s" }} />
      </Box>
    </Backdrop>
  );
}

const dotWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const dot = {
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: "#000",
  animation: "dotPulse 1.4s infinite ease-in-out both",
  "@keyframes dotPulse": {
    "0%, 80%, 100%": {
      transform: "scale(0)",
      opacity: 0.3,
    },
    "40%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
};
